import { usePage } from "@inertiajs/vue3";
import { computed } from "vue";

export type TranslationInterpolations = Array<string | number> | Record<string, string | number>;

const page = usePage();
export const i18n = computed(
    () => page.props?.i18n as Domain.Shared.Data.I18nMain & Domain.Shared.Data.I18nPP & Domain.Shared.Data.I18nAdmin & Domain.Shared.Data.I18nCustomer,
);

export * from "./d";
export * from "./n";
export * from "./t";
export * from "./tc";
